export class MyTeamInfo {
  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}
